<template>
<div>
    <cTicketingDetail  :ticketingDetail="ticketRowObj" :isBooking="false"
         @navFromDetail="navToTicketNowPage" />
</div>
</template>

<script>
import { addClassToBody,removeClassBody } from "../../../../util/util";
import { COMPONENT_NAME,PATHNAME,} from "../../../../util/constants";
import {mapGetters, mapActions} from "vuex";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../../../config/API_DATA";
import BaseConfiguration from "../../../../config/base";
import Logger from "../../../../services/logger";
import router, { navigate, goBack } from "../../../../router/index";
import cTicketingDetail from "../../../../components/ticketing/cTicketingDetail";
export default {
  name: COMPONENT_NAME.TICKETING_QUEUE_DETAIL,

  components: {
    cTicketingDetail
  },
 
 computed: {
    ...mapGetters("sTicketingQueue", {
      ticketRowObj: "GET_TICKETING_QUEUE"
    }),
     
   
  },

  methods:{
       ...mapActions("sTicketingQueue", {
     SET_TICK_QUEUE_REQ: "SET_TICK_QUEUE_REQ"
    }),

    ...mapActions("sCPaymentList", {
     SET_CURRENCY: "SET_CURRENCY"
    }),

      navToTicketNowPage(pTicketingDet) {
        try {
          if(BaseConfiguration.isDebug) console.log("navToTicketNowPage");
                    
          if(pTicketingDet){     
                 this.SET_TICK_QUEUE_REQ(pTicketingDet);

         this.SET_CURRENCY( this.formatCurrency(pTicketingDet.currency));

          }
          
          navigate(PATHNAME.TICKET_NOW);
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.TICKETING_QUEUE_DETAIL,
                  "error in navToTicketNowPage",
                  err.toString(),
                  "navToTicketNowPage",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        },

         formatCurrency(pCurrency) {
                try {
                  if(BaseConfiguration.isDebug) console.log("formatCurrency");
                  let currency=null;
                  if(pCurrency){
                  if(pCurrency.constructor==Array){
                    for(let i=0;i<pCurrency.length;i++){
                      if(pCurrency[i].hasOwnProperty('currency_code')){
                        currency=pCurrency[i].currency_code.code;
                      }else if(pCurrency[i].hasOwnProperty('code')){
                        currency=pCurrency[i].code;
                      }
                    }
                  }else if(pCurrency.constructor==Object){
                     if(pCurrency.hasOwnProperty('currency_code')){
                        currency=pCurrency.currency_code.code;
                      }else if(pCurrency.hasOwnProperty('code')){
                        currency=pCurrency.code;
                      }
                  }else{
                    currency=pCurrency;
                  }

                }
                return currency;
            
                } catch (err) {
                        let body = Logger.buildRequest(
                          COMPONENT_NAME.TICKETING_QUEUE_DETAIL,
                          "error in formatCurrency",
                          err.toString(),
                          "formatCurrency",
                          LOG_TYPE.ERROR
                        );
                        Logger.getResponse(body);
                      }
                  
                }, 
  },

  data() {
    return {
      

    };
  },
     beforeCreate() {    
   addClassToBody(COMPONENT_NAME.TICKETING_QUEUE_DETAIL);
  },
  
   beforeDestroy() {
       this.$root.$emit("toggle-sidebar-minimize", true);

       removeClassBody();
    },
}
</script>